import {
  EventsGetOrderByEndTimeEnum,
  EventsGetOrderByHealthEnum,
  EventsGetOrderByNameEnum,
  EventsGetOrderByStartTimeEnum,
  EventsGetOrderByStateEnum,
  EventsGetRequest,
} from '@nativewaves/nw-cloud-sdk/smep'
import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Workspaces/Events'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Events/Structure'
import { workspaceRoute } from 'pages/NWPlatform/Workspaces/Workspace/Routing'

export const eventsRoute = createRoute({
  getParentRoute: () => workspaceRoute,
  path: StaticRouteParameter.EVENTS,
  loader: () => ({
    crumb: t('entity:smep.event', { count: 2 }),
  }),
})

export const eventsLayoutRoute = createRoute({
  getParentRoute: () => eventsRoute,
  id: 'eventsLayout',
  component: Structure,
})

type EventsOverviewSearch = {
  query?: string
} & Partial<PickStartsWith<EventsGetRequest, 'timeRange'>> &
  Partial<PickStartsWith<EventsGetRequest, 'orderBy'>>

const sortProperties = [
  'orderByName',
  'orderByState',
  'orderByHealth',
  'orderByStartTime',
  'orderByEndTime',
] as const satisfies (keyof PickStartsWith<EventsGetRequest, 'orderBy'>)[]

const sortPropertyValues = new Map<keyof PickStartsWith<EventsGetRequest, 'orderBy'>, Record<string, string>>([
  ['orderByName', EventsGetOrderByNameEnum],
  ['orderByState', EventsGetOrderByStateEnum],
  ['orderByHealth', EventsGetOrderByHealthEnum],
  ['orderByStartTime', EventsGetOrderByStartTimeEnum],
  ['orderByEndTime', EventsGetOrderByEndTimeEnum],
])

export const eventsOverviewRoute = createRoute({
  getParentRoute: () => eventsLayoutRoute,
  path: '/',
  component: () => <Overview />,
  validateSearch: (search: Record<string, unknown>): EventsOverviewSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    if (search.timeRangeStart && typeof search.timeRangeStart === 'number' && !isNaN(search.timeRangeStart)) {
      result.timeRangeStart = search.timeRangeStart
    }

    if (search.timeRangeEnd && typeof search.timeRangeEnd === 'number' && !isNaN(search.timeRangeEnd)) {
      result.timeRangeEnd = search.timeRangeEnd
    }

    for (const sortProperty of sortProperties) {
      if (
        search[sortProperty] &&
        typeof search[sortProperty] === 'string' &&
        search[sortProperty] in sortPropertyValues.get(sortProperty)!
      ) {
        result[sortProperty] = search[sortProperty]
      }
    }

    return result satisfies EventsOverviewSearch
  },
})
